module.exports = __webpack_public_path__ + "img/edit_icon_hover.c505632a.svg";